import template from './games-ending-card.html';

export default class GamesEndingCardComponent {
  constructor() {
    this.template = template;
    this.bindings = {
      game: '<',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/games-ending/components/games-ending-card-component.js